// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"16851a35","453":"f56b8d49","667":"6441baff"}[chunkId] + ".chunk.js";
};